// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ToolTip_tooltip__3xu2Z","left":"ToolTip_left__Ic9if","right":"ToolTip_right__JcJ3T"};